import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Autocomplete,
  TextField
} from "@mui/material";
import SoftButton from "components/SoftButton";
import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import swal from "sweetalert2";
import { api } from "utils/Api";
import { useParams } from "react-router-dom";
import { showWarning } from "utils/messageAlerts";
import { showSuccess } from "utils/messageAlerts";
import { useHierarchy } from "context/HierarchyContext";
import { getSecureItem } from "utils/SecureStorage";

function AdminManagerAddPropertyPopup({ onClose, refreshData }) {
  const [loading, setLoading] = useState(false);
  const [assignedUserEmail, setAssignedUserEmail] = useState("");
  const [properties, setProperties] = useState([]);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const {orgId}= useHierarchy();
  const current_user_role_id = getSecureItem("role_id");
  const currentOrgId = JSON.parse(getSecureItem("currentUser"))?.organization_id;

  useEffect(() => {
    fetchProperties();
  }, []);

  const fetchProperties = async () => {
    try {
      const propertyData = await api.properties.getProperties({ organization_id: orgId || currentOrgId, current_user_role_id });
      setProperties(propertyData || []);
    } catch (e) {
      
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedProperty) {
      showWarning("Please select a property");
      return;
    }

    if (!assignedUserEmail) {
      showWarning("Please enter user email");
      return;
    }

    setLoading(true);

    try {
      await api.userProperty.createUserProperty({
        user_email: assignedUserEmail,
        property_id: selectedProperty.id,
        organization_id: selectedProperty.organization_id,
        user_role_id: 3,
        frontend_metadata: {},
        backend_metadata: {},
      });

      showSuccess("Manager assigned to property successfully");

      onClose();
      refreshData();
    } catch (error) {
    
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth="sm">
      <form onSubmit={handleSubmit}>
        <DialogTitle>Add User to Property</DialogTitle>

        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>

            {/* Searchable Property */}
            <SoftBox>
              <SoftTypography variant="caption" fontWeight="bold">
                Select Property <Box component="span" color="error.main">*</Box>
              </SoftTypography>

              <Autocomplete
                options={properties}
                getOptionLabel={(option) => option.name || ""}
                value={selectedProperty}
                onChange={(event, newValue) => setSelectedProperty(newValue)}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Search property..."
                    size="small"
                  />
                )}
              />
            </SoftBox>

            {/* User Email */}
            <SoftBox>
              <SoftTypography variant="caption" fontWeight="bold">
                User Email <Box component="span" color="error.main">*</Box>
              </SoftTypography>

              <SoftInput
                type="email"
                placeholder="Enter user email to assign as MANAGER"
                value={assignedUserEmail}
                onChange={(e) => setAssignedUserEmail(e.target.value)}
                required
              />
            </SoftBox>

          </Box>
        </DialogContent>

        <DialogActions>
          <SoftButton onClick={onClose}>Cancel</SoftButton>
          <SoftButton
            variant="gradient"
            color="dark"
            disabled={loading}
            type="submit"
          >
            {loading ? "Saving..." : "Save"}
          </SoftButton>
        </DialogActions>
      </form>
    </Dialog>
  );
}

AdminManagerAddPropertyPopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  refreshData: PropTypes.func.isRequired,
};

export default AdminManagerAddPropertyPopup;